import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { User, Mail, Crown, Calendar, AlertTriangle } from "lucide-react";
import { showToast } from '@/utils/toast';

const AccountModal = React.memo(({ 
  isOpen, 
  onClose,
  user,
  onDeleteAccount
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onDeleteAccount();
      showToast.success("Hesap silme talebiniz alındı");
      onClose();
    } catch (error) {
      showToast.error("Hesap silinemedi");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" aria-label="Hesap Bilgileri">
        <DialogHeader>
          <DialogTitle>Hesap Bilgileri</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <Card className="p-4 space-y-3">
            <div className="flex items-center gap-3">
              <User className="h-5 w-5 text-muted-foreground" />
              <div>
                <p className="text-sm text-muted-foreground">Ad Soyad</p>
                <p className="font-medium">{user?.name}</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <Mail className="h-5 w-5 text-muted-foreground" />
              <div>
                <p className="text-sm text-muted-foreground">E-posta</p>
                <p className="font-medium">{user?.email}</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <Crown className="h-5 w-5 text-muted-foreground" />
              <div>
                <p className="text-sm text-muted-foreground">Üyelik Tipi</p>
                <Badge variant={user?.subscription_tier === 'pro' ? 'default' : 'secondary'}>
                  {user?.subscription_tier === 'pro' ? 'PRO' : 
                   user?.is_trial ? 'Deneme' : 'Ücretsiz'}
                </Badge>
              </div>
            </div>
            
            {user?.is_trial && user?.trial_end_date && (
              <div className="flex items-center gap-3">
                <Calendar className="h-5 w-5 text-muted-foreground" />
                <div>
                  <p className="text-sm text-muted-foreground">Deneme Bitiş</p>
                  <p className="font-medium">
                    {new Date(user.trial_end_date).toLocaleDateString('tr-TR')}
                  </p>
                </div>
              </div>
            )}
          </Card>
          
          {!showDeleteConfirm ? (
            <Button 
              variant="destructive" 
              className="w-full"
              onClick={() => setShowDeleteConfirm(true)}
            >
              Hesabı Sil
            </Button>
          ) : (
            <Card className="p-4 space-y-3 border-destructive">
              <div className="flex items-start gap-2">
                <AlertTriangle className="h-5 w-5 text-destructive mt-0.5" />
                <div>
                  <p className="font-medium text-sm">Hesabınızı silmek istediğinizden emin misiniz?</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    Bu işlem geri alınamaz. Tüm verileriniz kalıcı olarak silinecektir.
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <Button 
                  variant="destructive" 
                  onClick={handleDelete}
                  disabled={deleting}
                  className="flex-1"
                >
                  {deleting ? "Siliniyor..." : "Evet, Sil"}
                </Button>
                <Button 
                  variant="outline" 
                  onClick={() => setShowDeleteConfirm(false)}
                  className="flex-1"
                >
                  İptal
                </Button>
              </div>
            </Card>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
});

AccountModal.displayName = 'AccountModal';

export default AccountModal;
